// #3475 (scribe-resilience): the ONE definition of "a station has gone silent",
// shared by score-api and scoreadmin-fe so the banner and any server-side
// reasoning can never disagree about when.
//
// #3427's stuck-station check runs only when a tablet UPLOADS a snapshot, so a
// tablet that is offline, dead or has its app closed never trips it. This is the
// other half: no contact at all for 2 minutes. Whether the station's ring is
// running (rides due now) is score-api's call, see lib/ring-running.js; this
// module only answers "how long has it been quiet".
//
// Pure: no clock, no I/O. Callers pass `now`.
import { unshippedAgeMs } from "./stuck-station.js";

export const SILENT_STATION_THRESHOLD_MS = 2 * 60 * 1000;

/** How long a station has been silent in ms, or null when its last contact is unknown/unreadable. */
export function silentForMs(lastSeenAt, now) {
  return unshippedAgeMs(lastSeenAt, now);
}

/**
 * True when the last contact is STRICTLY older than the threshold (exactly at
 * the threshold is not yet silent). Unknown contact is never silent: a row with
 * no contact time cannot be said to have gone quiet.
 */
export function isStationSilent(lastSeenAt, now, thresholdMs = SILENT_STATION_THRESHOLD_MS) {
  const age = silentForMs(lastSeenAt, now);
  if (age === null) return false;
  const limit = Number.isFinite(thresholdMs) && thresholdMs > 0 ? thresholdMs : SILENT_STATION_THRESHOLD_MS;
  return age > limit;
}
